import { render, staticRenderFns } from "./QuesFile.vue?vue&type=template&id=099a4a88&scoped=true&"
import script from "./QuesFile.vue?vue&type=script&lang=js&"
export * from "./QuesFile.vue?vue&type=script&lang=js&"
import style0 from "./QuesFile.vue?vue&type=style&index=0&id=099a4a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a4a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VFileInput,VRow,VTextarea})
